import { atom } from "recoil";

export type EventCouponType = {
  coupon_id: number;
  coupon_name: string;
  requirement: number;
  max_discount: number;
  coupon_type: number;
  price: number;
  percent: number;
  odds: number;
};

export type EventStateType = {
  event_id: number | null;
  event_name: string;
  event_type: number;
  visible: boolean;
  used: number;
  coupon: EventCouponType | null;
};

export const eventState = atom<EventStateType>({
  key: "event",
  default: {
    event_id: null,
    event_name: "",
    event_type: -1,
    visible: false,
    used: -1,
    coupon: null,
  },
});
